import axios from 'axios';
import { Toast } from 'vant';
import authStore from '@/store/auth';
import { getCookie, isWeChat } from '@/utils/helpers';
import javascriptBridge from '@/core/lib/javascript-bridge';
// 底部Toast提示
const bottomToast = (message) => {
  Toast({
    position: 'bottom',
    message,
  });
};

const AUTH_COOKIE_NAMES = ['Magiccube-Token', 'accessToken', 'refreshToken', 'Swj.Share'];

function clearAuthCookie(name) {
  if (typeof document === 'undefined') return;
  const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = `${name}=; expires=${expires}; path=/`;
  document.cookie = `${name}=; expires=${expires}; path=/; domain=.3vjia.com`;
  document.cookie = `${name}=; expires=${expires}; path=/; domain=.3weijia.com`;
}

function clearInvalidAuth() {
  authStore.commit('SET_ACCESS_TOKEN', '');
  authStore.commit('SET_REFRESH_TOKEN', '');
  AUTH_COOKIE_NAMES.forEach(clearAuthCookie);
}

function retryAnonymously(config, requestClient) {
  clearInvalidAuth();
  config.anonymousRetried = true;
  config.skipAuth = true;
  if (config.headers) {
    delete config.headers.access_token;
  }
  return requestClient(config);
}

// 基本应用请求实例
let platform;
if (javascriptBridge.device.android) {
  platform = 'Android';
} else if (javascriptBridge.device.ios) {
  platform = 'iOS';
}

// 区分端内或者端外
let h5Platform = '';
if (!javascriptBridge.device.swjApp) {
  if (isWeChat()) {
    h5Platform = 'wechat';
  } else {
    h5Platform = 'h5';
  }
}

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  timeout: 60000,
  headers: {
    Platform: platform,
    'H5-Platform': h5Platform,
    post: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
});

// 请求异常处理
const handleError = (error) => {
  if (error.response) {
    const { status } = error.response;
    if (status >= 400 && status < 500) {
      bottomToast('网络异常，请稍后再试');
    } else {
      bottomToast('系统繁忙，请稍后再试');
    }
  } else if (error.message.indexOf('timeout') !== -1) {
    bottomToast('请求超时，请稍后再试');
  } else {
    bottomToast('网络开小差了，请稍后再试');
  }
  return Promise.reject(error);
};

// 基本应用请求实例请求拦截器
request.interceptors.request.use(async (config) => {
  if (javascriptBridge.device.swjAppVersion) {
    config.headers.Version = javascriptBridge.device.swjAppVersion;
  }
  if (getCookie('deviceId')) {
    config.headers.Device = getCookie('deviceId');
  }
  // 账号体系测试
  if (process.env.NODE_ENV === 'development') {
    config.headers['Magiccube-Route-Label'] = 'develop-zhtx-ph1';
  }
  const { accessToken } = authStore.state;
  if (!config.skipAuth && accessToken) {
    config.headers.access_token = accessToken;
  } else if (config.headers) {
    delete config.headers.access_token;
  }
  return config;
}, handleError);

// 基本应用请求实例响应拦截器
request.interceptors.response.use(async (res) => {
  const {
    code, data, message, msg,
  } = res.data;
  switch (true) {
  case code === 200:
    return data;
  case code === 601: {
    const { config } = res;
    const { refreshToken } = authStore.state;
    if (!config.retried && refreshToken) {
      config.retried = true;
      try {
        const { accessToken } = await authStore.dispatch('refreshToken', {
          silent: config.allowAnonymousRetry,
        });
        config.headers.access_token = accessToken;
        return request(config);
      } catch (error) {
        if (config.allowAnonymousRetry && !config.anonymousRetried) {
          return retryAnonymously(config, request);
        }
        return Promise.reject(error);
      }
    }
    if (config.allowAnonymousRetry && !config.anonymousRetried) {
      return retryAnonymously(config, request);
    }
    return Promise.resolve();
  }
  case code === 140011016:
    return Promise.resolve();
  default:
    bottomToast(message || msg);
    return Promise.reject(res.data);
  }
}, handleError);

export default request;

export {
  request,
};
